<template>
    <div class="checkbox-cell">
        <input
            type="checkbox"
            :id="record._id + '_' + field._id"
            v-model="value" @change="updateValue" class="hidden-checkbox"
        />
        <label :for="record._id + '_' + field._id" class="custom-label">
            <span v-if="value" class="icon">✔</span>
        </label>
    </div>
</template>

<script>
import Vue from "vue";
import PermissionController from "../../../../../components/permission-controller/PermissionController";

export default Vue.extend({
    name: "CheckboxCell",
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: this.record.data[this.field._id] || false,
        };
    },
    methods: {
        async updateValue(event) {
            if (!PermissionController.check(["table.update"])) {
                PermissionController.sendError();
                return;
            }
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            const newValue = event.target.checked;
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: newValue,
                });
                this.value = newValue;
            } catch (error) {
                console.error(this.$t("tables.recordUpdatingError"), error);
                this.$message.error(this.$t("tables.recordUpdatingError"));
            }
        },
    },
});
</script>

<style scoped lang="scss">
.checkbox-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;

    .hidden-checkbox {
        display: none;
    }

    .custom-label {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background-color: #f0f0f0;
        border: 2px solid #d9d9d9;
        border-radius: 50%;
        cursor: pointer;
        transition: background-color 0.3s ease;
        position: relative;

        .icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 1.2em;
            color: white;
            opacity: 0;
            transition: opacity 0.3s ease;
        }
    }

    .hidden-checkbox:checked + .custom-label {
        background-color: #1890ff;
        border-color: #1890ff;

        .icon {
            opacity: 1;
        }
    }
}
</style>
